import { GROK_API_KEY, GROK_STT_URL, GROK_TTS_URL } from "@/constants/grok";

export async function transcribeAudio(blob: Blob): Promise<string> {
  const formData = new FormData();
  formData.append("file", blob, "audio.webm");
  formData.append("model", "whisper-large-v3");

  const res = await fetch(GROK_STT_URL, {
    method: "POST",
    headers: { Authorization: `Bearer ${GROK_API_KEY}` },
    body: formData,
  });
  const data = await res.json();
  return data.text as string;
}

export async function speakText(text: string): Promise<HTMLAudioElement> {
  const response = await fetch(GROK_TTS_URL, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${GROK_API_KEY}`,
      "Content-Type": "application/json",
      Accept: "audio/mpeg",
    },
    body: JSON.stringify({
      model: "playai-tts",
      voice: "Fritz-PlayAI",
      input: text,
    }),
  });

  if (!response.ok || !response.body) {
    throw new Error("Failed to synthesize speech");
    }

  const reader = response.body.getReader();
  const mediaSource = new MediaSource();
  const audio = new Audio();
  audio.src = URL.createObjectURL(mediaSource);

  mediaSource.addEventListener("sourceopen", async () => {
    const sourceBuffer = mediaSource.addSourceBuffer("audio/mpeg");
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        mediaSource.endOfStream();
        break;
      }
      if (value) {
        sourceBuffer.appendBuffer(value);
        await new Promise((resolve) =>
          sourceBuffer.addEventListener("updateend", resolve, { once: true })
        );
      }
    }
  });

  return audio;
}
